<!-- 挂载设备弹出模态框（设备复选表） -->
<template>

    <div>

        <el-dialog
                title="设备"
                :visible.sync="visible"
                width="80%"
                @close="close">

            <el-row class="bottom20">
                <el-table :data="tableData"
                          ref="multipleTable"
                          highlight-current-row
                          @selection-change="handleSelectionChange"
                          style="width: 100%">
                    <el-table-column
                            type="selection"
                            width="55">
                    </el-table-column>
                    <el-table-column prop="code" label="设备编号">
                        <template slot="header" slot-scope="scope">
                            设备编号<br>
                            <el-input size="mini" v-model="searchParams.like_code"
                                      class="width70"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="设备名称">
                        <template slot="header" slot-scope="scope">
                            设备名称<br>
                            <el-input size="mini" v-model="searchParams.like_name"
                                      class="width70"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column prop="description" label="设备描述">
                        <template slot="header" slot-scope="scope">
                            设备描述<br>
                            <el-input size="mini" v-model="searchParams.description"
                                      class="width70"></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <el-row type="flex" class="row-bg" justify="end">
                <el-pagination align="right"
                               @current-change="handleCurrentChange"
                               @size-change="handleSizeChange"
                               :current-page="currentPage"
                               :page-sizes="pageSizes" :page-size="pageSize"
                               layout="total, sizes, prev, pager, next, jumper"
                               :total="total">
                </el-pagination>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelFunc">取 消</el-button>
                <el-button type="primary" @click="confirmFunc">确 定</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>

    import {debounce} from "@/util";
    import {queryPage} from '@/api/equipment/equipment-list.js'

    export default {

        name: "company_dialog",

        data() {
            return {

                multipleSelection: [],

                currentPage: 1,
                pageSize: 10,
                total: 0,
                pageSizes: [10, 25, 50, 100],

                searchParams: {
                    roomId: '',
                    like_code: '',
                    like_name: '',
                    description: '',
                },

                tableData: [],
            }
        },

        props: {
            visible: {
                type: Boolean,
            },

            singleFlag: {       //是否仅允许单选
                type: Boolean,
                default: false,
            },

            roomId: {
                type: Number,
            },
        },

        methods: {

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            queryTable() {
                let params = {
                    'search': {
                        ...this.searchParams
                    },
                    'current': this.currentPage,
                    'size': this.pageSize,
                };
                queryPage(params).then(res => {
                    this.total = res.total;
                    this.tableData = res.records;
                });
            },

            close() {
                this.searchParams.like_code = '';
                this.searchParams.like_name = '';
                this.searchParams.description = '';
                this.currentPage = 1;
                this.$refs.multipleTable.clearSelection();
                this.$emit('update:visible', false);
            },

            cancelFunc() {
                this.close();
            },

            confirmFunc() {
                if (this.singleFlag == true) {
                    if (this.multipleSelection.length > 1 || this.multipleSelection.length == 0) {
                        this.$message.error('仅允许选择一个设备');
                        return;
                    }
                    this.$emit('afterSingleSelectFunc', this.multipleSelection[0]);
                    this.close();
                } else {
                    this.$emit('afterMultSelectFunc', this.multipleSelection);
                    this.close();
                }
            },

        },

        watch: {

            searchParams: {
                deep: true,
                immediate: true,
                handler: debounce(function (newVal, oldVal) {
                    this.currentPage = 1;
                    this.queryTable();
                }, 500)
            },

            roomId: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    this.searchParams.roomId = newVal;
                    this.currentPage = 1;
                    this.queryTable();
                }
            },

        },

        mounted() {
            // this.queryTable();
        },

    }


</script>
